module.exports = __webpack_public_path__ + "static/media/backyard_rock garden_sketch_renee.79acbef5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-la/backyard_rock garden_sketch_renee.jpg
// module id = 433
// module chunks = 0